<template>
    <div class="big-data">
        <div v-if="homeFlag">
            <Index />
            <router-view />
        </div>
        <div v-else>
            <Home />
        </div>
        <Footer />
    </div>
</template>
<script>
import Index from './../index/index.vue'
import Home from './../index/home.vue'
import Footer from '@/components/common/footer'

export default {
    components: {
        Index, Home, Footer
    },
    data() {
        return {
            homeFlag: this.$route.name == 'statistic' ? true : false
        }
    },
    watch: {
        '$route' (to, from) {
            this.homeFlag = this.$route.name == 'statistic' ? true : false;
        }
    }
}
</script>
<style lang="scss">
    .big-data {
        .title-box {
            position: relative;
            padding-top: 20px;
            padding-left: 25px;
            margin-bottom: 19px;
        }

        .head-title {
            padding: 3px 10px;
            border-left: 4px solid #4eb446;
            text-align: left;
            font-size: 16px;
            color: #fff;
        }

        .fs4, .fs5, .fs6, .fs7, .fs8, .fs9, .fs10, .fs11, .fs12, .fs13 {
            display: inline-block;
            background-image: url(../../../../public/images/fs.4b26f15c.png);
            background-repeat: no-repeat;
        }

        .fs4 {                            
            background-position: 0px -257px;
            width: 62px;
            height: 118px;
        }

        .fs5 {
            background-position: -402px 0px;
            width: 86px;
            height: 55px;
        }

        .fs6 {
            background-position: -306px -130px;
            width: 86px;
            height: 61px;
        }

        .fs7 {
            vertical-align: sub;
            margin-right: 36px;
            width: 40px;
            height: 36px;
            background-position: -402px -215px;                                    
        }

        .fs8 {
            vertical-align: sub;
            margin-right: 36px;
            width: 40px;
            height: 36px;
            background-position: -402px -261px;
        }

        .fs9 {
            background-position: 0px 0px;
            width: 152px;
            height: 119px;
        }

        .fs10 {
            background-position: 0px -129px;
            width: 100px;
            height: 118px;
        }

        .fs11 {
            background-position: -306px 0px;
            width: 86px;
            height: 120px;
        }

        .fs12 {
            background-position: -160px 0px;
            width: 135px;
            height: 120px;
        }

        .fs13 {
            background-position: -105px -129px;
            width: 100px;
            height: 118px;
        }
    }
</style>
